import { PaymentInfoSchema } from '@vy/types';
import type { oz } from '@vy/utils';

export const PaymentInfoFormSchema = PaymentInfoSchema.extend({
  date: PaymentInfoSchema.shape.date.nullable(),
});

export type PaymentInfoFormType = oz.infer<typeof PaymentInfoFormSchema>;
